import React, {Component} from "react"
import {Container, Form, Header, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsOpenEnrollment, checkIsVerified, convertDisplayDateFormatToServer, COVERAGE_DECLINED_PATH, ELIGIBILITY_LOSS, getEnrollmentTimezone, getStepProps, isAnsel, isDistributionChannelIndividual, NO_CONTRACT_TO_ENROL, NOT_IN_OPEN_ENROLLMENT_ROUTE, savePoints, SUMMARY_RETURNING_ROUTE, uiFlowBenAdmin} from "../utils/common";
import Steps from "./steps/steps";
import {resetUserData, setAccount, setBirthdate, setEnrollmentReceivedDate, setGender, setSsn, setUserInfo, setValidSsnVerification} from "../actions/userActions";
import Footer from "./footer";
import {setBenAdminLastName, setBenAdminName} from "../actions/benAdminActions";
import ErrorEmptyFormInput from "./errorEmptyFormInput";
import moment from "moment";
import 'moment-timezone';
import {setCensusEeAddress, setEtContractTermsData, setVerifyResponseData} from "../actions/initialDataActions";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {SupportEmailLink} from "./base";
import {CustomGrid, DOBInput, SSNInput} from "./custom-common";
import {DateSelector} from "./custom-common/dateSelector";
import {VerifyIdentityBenAdminRequest, VerifyIdentityRequest} from "../services/types";
import {verifyIdentity, verifyIdentityBenAdmin} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        ...ownProps,
        isBenAdmin: initialData.uiFlow === uiFlowBenAdmin,
        isIndividual: isDistributionChannelIndividual(initialData.distributionChannel),
        benAdmin: benAdmin,
        userSsn: user.ssn,
        user: user,
        lang: user.lang,
        initialData: initialData,
        birthdate: user.birthdate,
        stateOptions: initialData.stateOptions,
    }
};

class VerifyItsYou extends Component {
    constructor(props) {
        super(props);
        let ssn = '';
        if (!!props.userSsn) {
            ssn = props.userSsn;
        }
        this.state = {
            stepProps: null,
            ssn,
            errorMessage: '',
            loading: false,
            firstName: '',
            lastName: '',
            dobError: false,
            enrollmentReceivedDate: '',
            selectedState: '',
            stateError: false,
            ssnError: false,
        }
    }

    componentDidMount() {
        const {initialData, user, benAdmin, isBenAdmin, isIndividual} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();

        if (isBenAdmin) {
            this.setState({firstName: benAdmin.name, ...(isIndividual && {lastName: benAdmin.lastName})})
        } else {
            this.setState({ssn: ''});
            const {firstName, lastName} = user;
            this.props.dispatch(resetUserData());
            this.props.dispatch(setUserInfo("SET_FIRST_NAME", firstName));
            this.props.dispatch(setUserInfo("SET_LAST_NAME", lastName));
        }
    }

    handleFormChange = (e, {name, value}) => {
        this.setState({
            [name]: value,
            errorMessage: '',
        });
    }

    handleSSNChange = (ssn) => {
        this.setState({
            ssn,
            ssnError: false,
            errorMessage: '',
        });
    }

    handleBirthDateChange = (event, {value}) => {
        this.props.dispatch(setBirthdate(value));
        this.setState({
            errorMessage: '',
            dobError: false,
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    handleRestoreUserProgress = async (userProgressObj) => {
        const {data, enrolleeSfId} = userProgressObj;
        let didChangeUserRoute = false;

        if (!!data && !!data.user) {
            data.user.enrolleeSfId = enrolleeSfId;

            await this.props.dispatch(setUserInfo("OVERWRITE_STATE",data.user));
            if (!!data.user.lastVisitedSavePoint) {
                const savePointRoute = !!data.user && !!data.user.lastVisitedSavePoint && data.user.lastVisitedSavePoint.route;
                const savePoint = savePoints[savePointRoute]
                if (!!savePoint && savePoint.redirectTo !== this.props.nextRoute) {
                    didChangeUserRoute = true;
                    this.props.history.push(savePoint.redirectTo);
                }
            }
        } else {
            this.props.dispatch(setUserInfo("SET_ENROLLEESFID", enrolleeSfId));
        }
        return didChangeUserRoute;
    }

    handleSubmit = async () => {
        const {isBenAdmin} = this.props;
        if (isBenAdmin) {
            await this.benAdminSubmit()
        } else {
            await this.submit()
        }
    };

    benAdminSubmit = async () => {
        this.setState({loading: true});
        const {firstName, lastName, selectedState} = this.state;
        const {birthdate, initialData: {token}, isIndividual} = this.props;
        try {
            const request = new VerifyIdentityBenAdminRequest({
                birthDate: convertDisplayDateFormatToServer(birthdate),
                state: selectedState,
                token,
            })
            const response = await verifyIdentityBenAdmin(request);
            if (!response || response.status !== 200) {
                throw new Error(response?.statusText || 'Invalid response from server');
            }
            const {policy, eligibility, limitations, frauds, stopScreenForUnderaged}= response.data;
            this.setState({loading: false});
            if (stopScreenForUnderaged) {
                return this.props.history.replace(ELIGIBILITY_LOSS)
            }
            this.props.dispatch(setEtContractTermsData({policy, eligibility, limitations, frauds}));
            this.props.dispatch(setBenAdminName(firstName));
            if (isIndividual) {
                this.props.dispatch(setBenAdminLastName(lastName));
            }
            this.props.history.push(this.props.nextRoute);
        } catch (e) {
            let err = e?.response?.data?.errorMessage;
            if (err?.includes("Ineligible due to state")) {
                this.props.history.push(ELIGIBILITY_LOSS);
            }
            const {welcome: strings} = getLocalization(this.props.lang);
            this.setState({
                loading: false,
                invalidToken: true,
                errorMessage: err || strings.invalidInformation,
            });
        }
    }

    submit = async () => {
        this.setState({loading: true});
        const {ssn, enrollmentReceivedDate} = this.state;
        const {birthdate, initialData} = this.props;
        try {
            const {isPaperEnrollment, token, quoteInfo} = initialData;
            const request = new VerifyIdentityRequest({
                birthDate: convertDisplayDateFormatToServer(birthdate),
                enrollmentReceivedDate: isPaperEnrollment ? convertDisplayDateFormatToServer(enrollmentReceivedDate) : null,
                quoteInfo,
                ssn,
                token,
            })
            const response = await verifyIdentity(request);
            if (response.status !== 200) {
                throw Error(response.statusText);
            }
            const {data} = response;
            const {isEligibilityLoss} = data;
            if (isEligibilityLoss) {
                this.props.history.push(ELIGIBILITY_LOSS);
            } else {
                const hasContractToEnrol = data.hasContractToEnrolTo;
                window.onbeforeunload = function (event) {
                    event.preventDefault();
                    event.returnValue = '';
                };

                this.props.dispatch(setValidSsnVerification());
                this.props.dispatch(setSsn(ssn));
                if (isPaperEnrollment) {
                    this.props.dispatch(setEnrollmentReceivedDate(enrollmentReceivedDate));
                }
                const {enrollmentDeclined, isConverted, account} = data;
                if (!!enrollmentDeclined) {
                    this.props.history.push(COVERAGE_DECLINED_PATH);
                    return;
                }
                this.props.dispatch(setGender(data.gender));
                this.props.dispatch(setVerifyResponseData(data));
                this.props.dispatch(setCensusEeAddress(data.address));
                if (isConverted != null && isConverted) {
                    if (account === null) {
                        const localization = getLocalization(this.props.lang);
                        let strings = localization.verifyItsYou;
                        const errorMessage = strings.accNotFound;
                        this.setState({
                            loading: false,
                            invalidToken: true,
                            errorMessage,
                        });
                    } else {
                        this.props.dispatch(setAccount(data.account));
                        this.props.history.push(SUMMARY_RETURNING_ROUTE);
                    }
                } else {
                    const {enrollmentStartDate, enrollmentEndDate} = data;
                    const start = moment(enrollmentStartDate);
                    const end = moment(enrollmentEndDate);
                    const isOpenEnrollment = checkIsOpenEnrollment(start, end, getEnrollmentTimezone(initialData));

                    const now = moment().tz(getEnrollmentTimezone(initialData));
                    const isBeforeOpenEnrollment = moment(now.format("YYYY-MM-DD")).isBefore(start);
                    if (!hasContractToEnrol) {
                        this.props.history.push(NO_CONTRACT_TO_ENROL);
                    } else {
                        if (isOpenEnrollment || isBeforeOpenEnrollment || !!isPaperEnrollment) {
                            const didHandleRouting = await this.handleRestoreUserProgress(data.userProgress);
                            if (!didHandleRouting) {
                                this.props.history.push(this.props.nextRoute);
                            }
                        } else {
                            this.props.history.push(NOT_IN_OPEN_ENROLLMENT_ROUTE);
                        }
                    }
                }
            }
        } catch (e) {
            let err = undefined;
            if (!!e && !!e.response && !!e.response.data) {
                console.log(e.response.data);
                if (e.response.data.errorMessage) err = e.response.data.errorMessage;
            } else {
                console.log({e});
            }
            const localization = getLocalization(this.props.lang);
            const strings = localization.welcome;
            this.setState({
                loading: false,
                invalidToken: true,
                errorMessage: err ? err : strings.invalidInformation
            })
        }
    };

    setError = (msg) => {
        this.setState({
            dobError: msg,
        })
    }

    setSSNError = (value) => {
        this.setState({
            ssnError: value,
        })
    }

    renderErrorMessage = (strings) => {
        const errorMsg = this.state.errorMessage === "CLASS_NOT_FOUND" ? strings.classNotFound : strings.weWereUnable
        const contactMsg = this.state.errorMessage === "CLASS_NOT_FOUND" ? strings.pleaseContact : strings.stillHavingTr
        return (
            <div className={'verifyItsYouError small'}>
                <div style={{marginBottom: '0.5em'}}>
                    <b>{errorMsg}</b>
                </div>
                <p style={{whiteSpace: 'pre-line'}}>
                    {`${contactMsg} `}<span className={'spaceNoWrap'}>{STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER}</span>
                    {` ${strings.or} `}
                    <SupportEmailLink/>
                </p>
            </div>
        )
    }

    isStateInStateOptions(state) {
        const {stateOptions} = this.props
        return stateOptions.filter(el => el.value === state).length > 0
    }

    handleStateChange(e, {value}) {
        this.setState({
            selectedState: value,
            errorMessage: '',
            stateError: false,
        })
        if (!this.isStateInStateOptions(value)) {
            this.setState({stateError: true})
        }
    }

    render() {
        const {stepProps, dobError, ssn, firstName, lastName, enrollmentReceivedDate, stateError, ssnError, selectedState} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }
        const {birthdate, isBenAdmin, isIndividual, initialData: {isPaperEnrollment}, stateOptions} = this.props;
        const localization = getLocalization(this.props.lang);
        let strings = isBenAdmin ? localization.benVerifyItsYou : localization.verifyItsYou;
        const hasError = this.state.errorMessage.length > 0;
        const missingData = isBenAdmin ? !birthdate || !firstName || !selectedState || (isIndividual && !lastName) : !birthdate || !ssn;
        const disableSubmit = hasError || missingData || dobError || ssnError;
        return (
            <React.Fragment>
                <Container>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`}>
                    <CustomGrid.Row>
                        <CustomGrid.Column textAlign='center'>
                            <Header as='h2' textAlign='center'>
                                {parseMultilineString(strings.subTitle)}
                            </Header>
                        </CustomGrid.Column>
                    </CustomGrid.Row>
                    <CustomGrid.Row>
                        <CustomGrid.Column textAlign='left' className="verifyFormColumn">
                            <Form>
                                <Form.Group>
                                    {isBenAdmin &&
                                        <ErrorEmptyFormInput
                                            value={firstName}
                                            onChange={this.handleFormChange}
                                            name="firstName"
                                            label={strings.firstName}
                                            required
                                            width={12}
                                        />
                                    }
                                </Form.Group>
                                {isIndividual &&
                                    <Form.Group>
                                        <ErrorEmptyFormInput
                                            value={lastName}
                                            onChange={this.handleFormChange}
                                            name="lastName"
                                            label={strings.lastName}
                                            required
                                            width={12}
                                        />
                                    </Form.Group>
                                }
                                <Form.Group>
                                    <Form.Field required width={12}>
                                        <DOBInput
                                            value={!!birthdate ? birthdate : ""}
                                            label={strings.birthdate}
                                            setFormError={(msg) => {this.setError(msg)}}
                                            onChange={(event, {value}) => {
                                                this.handleBirthDateChange(event, {value, name: 'birthdate'});
                                            }}
                                            required
                                        />
                                        {isBenAdmin &&
                                            <div style={{display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: '55px'}}>
                                                <span className={"smaller neutral700Text"}>{strings.ageImpact}</span>
                                            </div>
                                        }
                                    </Form.Field>
                                </Form.Group>
                                {isBenAdmin &&
                                    <Form.Group>
                                        <Form.Field required
                                                    width={12}>
                                            <Form.Select required
                                                         error={stateError}
                                                         label={strings.stateOfResidence}
                                                         value={!this.state.selectedState ? '' : this.state.selectedState}
                                                         disabled={false}
                                                         options={stateOptions}
                                                         search
                                                         onChange={(event, {value, name}) => {
                                                             this.handleStateChange(event, {value, name});
                                                         }}
                                            />
                                            <div style={{display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: '55px'}}>
                                                {stateError &&
                                                    <span className={"smaller errorText"} style={{justifyContent: "normal"}}>
                                                     {strings.coverageNotAvailableForSelectedState}
                                                    </span>
                                                }
                                                <span className={"smaller neutral700Text"} style={{alignSelf: "flex-end"}}>
                                                   {strings.whereYouLive}
                                                </span>
                                            </div>
                                        </Form.Field>
                                    </Form.Group>
                                }
                                <Form.Group>
                                    {!isBenAdmin &&
                                        <SSNInput
                                            label={strings.ssn}
                                            onChange={(_, value) => {
                                                this.handleSSNChange(value);
                                            }}
                                            required
                                            setSSNError={this.setSSNError}
                                            value={ssn}
                                            width={12}
                                        />
                                    }
                                </Form.Group>
                                {isPaperEnrollment &&
                                    <Form.Group>
                                        <Form.Field required width={12}>
                                            <DateSelector value={enrollmentReceivedDate} fluid
                                                      label={strings.enrollmentReceivedDate}
                                                      setFormError={(msg) => {this.setError(msg)}}
                                                      onChange={(e, { value }) => {
                                                          this.handleFormChange(e, {
                                                              name: "enrollmentReceivedDate",
                                                              value: value,
                                                          });
                                                      }}
                                                      name="enrollmentReceivedDate"
                                                      required
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                }
                                {hasError && this.renderErrorMessage(strings)}
                            </Form>
                        </CustomGrid.Column>
                    </CustomGrid.Row>
                    <CustomGrid.Row>
                        <CustomGrid.Column textAlign='center' width={5}>

                        </CustomGrid.Column>
                    </CustomGrid.Row>
                </CustomGrid>
                </Container>
                <Footer
                    buttonText={strings.nextButton}
                    disabled={disableSubmit}
                    hideLimitationsAndExclusions
                    loading={this.state.loading}
                    onClickCallback={this.handleSubmit}
                    showCenterData
                    showTopFooter
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(VerifyItsYou));
